/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { createContext, useState } from "react";
import styles from "./styles.module.css";

export const LocationDialogContext = createContext({});

const LocationDialog = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSucceed, setIsSucceed] = useState(false);
  const [onSave, setOnSave] = useState([]);
  const [onCancel, setOnCancel] = useState([]);

  const [isShow, setIsShow] = useState(false);

  const showLocationDialog = ({ onPressSave, onPressCancel }) => {
    setIsShow(true);
    setTimeout(() => {
      setOnSave([onPressSave]);
      setOnCancel([onPressCancel]);
    }, 500);
  };

  const hideLocationDialog = () => {
    setIsShow(false);
    setOnSave([]);
    setOnCancel([]);
  };

  return (
    <LocationDialogContext.Provider
      value={{ isShow, showLocationDialog, hideLocationDialog, setIsSucceed, setIsLoading }}
    >
      {children}
      {isShow ? (
        <div className={styles.dialogContainer}>
          <div className={styles.boxContainer}>
            <div className={styles.header}>
              <span>Location</span>
            </div>
            <div className={styles.body}>
              <span>Please confirm you want to switch all sessions.</span>
            </div>
            <div className={styles.footer}>
              <button
                className={[styles.button, styles.save].join(" ")}
                type="button"
                style={{ position: "relative" }}
                onClick={onSave[0]}
              >
                {isLoading ? (
                  <div
                    id="results-loading-icon"
                    className="saving-white-ico icon-64"
                    style={{ width: 15, height: 15, marginRight: 3, position: "absolute", left: 50 }}
                  />
                ) : null}
                {isSucceed ? (
                  <div
                    className="check-flat-ico icon-64"
                    style={{ width: 15, height: 15, marginRight: 3, position: "absolute", left: 50 }}
                  />
                ) : null}
                Confirm
              </button>
              <button className={styles.button} type="button" onClick={onCancel[0]}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </LocationDialogContext.Provider>
  );
};

export default LocationDialog;
